import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AssignedPermissionSets } from '../store/assigned-permissionsets/assigned-permissionsets.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class AssignedPermissionSetsService {
  private apiUrl = eps.permissionSet.permissionSetApi

  constructor(private http: HttpClient) {}

  // getAssignedPermissionSets(
  //   params?: string | null,
  //   page?: number,
  //   limit?: number
  // ): Observable<any> {
  //   const url = params
  //     ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
  //     : `${this.apiUrl}?page=${page}&limit=${limit}`
  //   return this.http.get<any>(url)
  // }

  getAssignedPermissionSets(
    employeeId: string,
    params?: string | null,
    page?: number,
    limit?: number
  ): Observable<any> {
    // Build query params
    const queryParams = `${params}&page=${page ?? 1}&limit=${limit ?? 10}`

    // Construct URL using employeeId in the path
    const url = `${this.apiUrl}/user/assigned/${encodeURIComponent(employeeId)}?${queryParams}`

    return this.http.get<any>(url)
  }

  createAssignedPermissionSets(assignedPermissionSets: {
    validUpto?: string
    permissionSetIds: number[]
    userId: string
  }): Observable<AssignedPermissionSets[]> {
    return this.http.post<AssignedPermissionSets[]>(`${this.apiUrl}`, assignedPermissionSets)
  }

  updateAssignedPermissionSets(assignedPermissionSets: {
    id: string
    validUpto: string
    userRoleId: number
    userId: string
  }): Observable<AssignedPermissionSets> {
    return this.http.put<AssignedPermissionSets>(
      `${this.apiUrl}/${assignedPermissionSets.id}`,
      assignedPermissionSets
    )
  }
}
